<template>
  <div ref="collapse" class="collapse-box">
    <div class="collapse-box-btn" @click="onTriggerCollapse">
      <CustomIcon :name="icon" :font-size="24" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import CustomIcon from '@/components/CustomIcon.vue'
import { useCommonStore } from '@/store/useCommonStore'

const store = useCommonStore()

const collapse = ref()

const icon = computed(() => (store.isCollapse ? 'expand' : 'fold'))

const onTriggerCollapse = () => {
  store.isCollapse = !store.isCollapse
}

defineExpose({
  scrolling() {
    collapse.value.classList.add('scrolling')

    return () => {
      collapse.value.classList.remove('scrolling')
    }
  },
})
</script>
<style lang="scss" scoped>
.collapse-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 44px;
  padding: 13px 0 13px 32px;
  transition: padding var(--el-transition-duration), color var(--el-transition-duration);
  @apply select-none bg-[rgba(0,0,0,0.3)];

  &.scrolling {
    @apply relative z-[10];
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.4);
  }

  .collapse-box-btn {
    margin-left: -4px;
    padding: 4px;
    @apply rounded;

    &:hover {
      @apply cursor-pointer;
      @apply bg-[#0b79a3];
    }
  }
  :deep(svg) {
    color: #fff;
  }
}
</style>
